// extracted by mini-css-extract-plugin
export var content = "_qo-1";
export var fullScreen = "_qo-0";